'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'fish-bones';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e304';
var svgPathData = 'M32 96l-32 32 64 128-64 128 32 32 64-64 0-72 40 0 0 96 48 0 0-96 48 0 0 96 48 0 0-96 48 0 0 96 48 0 0-96 40 0 0 120 32 0 128-144-128-144-32 0 0 120-40 0 0-96-48 0 0 96-48 0 0-96-48 0 0 96-48 0 0-96-48 0 0 96-40 0 0-72-64-64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFishBones = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;